/* eslint-disable no-unused-vars, valid-jsdoc */
/**
 * @typedef {callback} _
 * @param {?} accumulator
 * @param {?} currentValue
 * @param {Number=} index
 * @param {[]=} array
 */
function callback(accumulator, currentValue, index, array) {}

export default callback;
